import { CSSProperties, FC } from 'react';

export interface SvgWhiteLoaderProps {
  size?: string; // size of square container
  style?: CSSProperties; // not for height or width
}

export const SvgWhiteLoader: FC<SvgWhiteLoaderProps> = ({
  size = '24px',
  style,
}) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...style,
      height: size,
      width: size,
    }}
  >
    <div
      style={{
        position: 'relative',
        height: 0,
        width: '100%',
        padding: 0,
        paddingBottom: '100%',
      }}
    >
      <svg
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          left: 0,
          top: 0,
        }}
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          opacity=".16"
          cx="18"
          cy="18"
          r="16"
          stroke="#FEFAF5"
          strokeWidth="4"
          fill="currentColor"
        />
        <path
          d="M34 18c0-8.837-7.163-16-16-16"
          stroke="#FEFAF5"
          strokeWidth="4"
          strokeLinecap="round"
          fill="currentColor"
        />
      </svg>
    </div>
  </div>
);
